import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import Sidebar from './Sidebar/Sidebar.vue'
import Switch from './Switch.vue'
import PInput from './custom/PInput.vue'
import PDropdown from './custom/PDropdown.vue'
import PMultiselect from './custom/PMultiselect.vue'
import PSelect from './custom/PSelect.vue'
import PDateTime from './custom/PDatetime.vue'
import PRadio from './custom/PRadio.vue'
import PSwitch from './custom/PSwitch.vue'
import PImage from './custom/PImage.vue'

export {
  Aside,
  Breadcrumb,
  Callout,
  Footer,
  Header,
  Sidebar,
  Switch,
  PInput,
  PDropdown,
  PMultiselect,
  PSelect,
  PDateTime,
  PRadio,
  PSwitch,
  PImage
}



// WEBPACK FOOTER //
// ./src/components/index.js